import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { AuthProvider } from './context/AuthContext';
import { I18nProvider } from './i18n/I18nContext';
import { HomePage } from './pages/HomePage';
import { MovieDetailPage } from './pages/MovieDetailPage';
import { PaymentSuccessPage } from './pages/PaymentSuccessPage';
import { PlaybackPage } from './pages/PlaybackPage';

function App() {
  return (
    <HelmetProvider>
      <I18nProvider>
        <BrowserRouter>
          <AuthProvider>
            <Header />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<Navigate to="/" replace />} />
              <Route path="/signup" element={<Navigate to="/" replace />} />
              <Route path="/auth/callback" element={<Navigate to="/" replace />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/movies/:id" element={<MovieDetailPage />} />
              <Route path="/watch/:id" element={<PlaybackPage />} />
              <Route path="/guest-watch/:accessToken" element={<PlaybackPage />} />
              <Route path="/rentals" element={<Navigate to="/" replace />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Footer />
          </AuthProvider>
        </BrowserRouter>
      </I18nProvider>
    </HelmetProvider>
  );
}

export default App;
